(() => {
  const STYLE_ID = 'buckscc-float-override';
  const OPEN_CLASS = 'buckscc-float-open';
  const CLOSED_CLASS = 'buckscc-float-closed';
  const SYNC_DELAYS = [0, 50, 120, 350, 600, 1000];

  const CSS = `
    html body div.hxoSelectTheme.hxo-mobile_relative .buckscc-select ul.buckscc-select-options,
    html body div.hxoSelectTheme.hxo-mobile_relative ul.buckscc-select-options,
    html body .hxoSelectTheme.hxo-mobile_relative .buckscc-select .buckscc-select-styled + ul.buckscc-select-options,
    html body .hxoSelectTheme.mobile_bottom_right .buckscc-select ul.buckscc-select-options,
    html body .hxoSelectTheme.mobile_bottom_left .buckscc-select ul.buckscc-select-options,
    html body .hxoSelectTheme.mobile_left_downwards .buckscc-select ul.buckscc-select-options,
    html body .hxoSelectTheme.mobile_right_downwards .buckscc-select ul.buckscc-select-options {
      top: auto !important;
      bottom: calc(100% + 4px) !important;
    }
  `;

  function injectOverride() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.body.appendChild(style);
  }

  function getOptions(trigger) {
    const options = trigger?.nextElementSibling;
    return options?.classList.contains('buckscc-select-options') ? options : null;
  }

  function isOpen(trigger) {
    return trigger.classList.contains('active') && !trigger.classList.contains('deactive');
  }

  function clearVisibilityInline(options) {
    options.style.removeProperty('display');
    options.style.removeProperty('visibility');
    options.style.removeProperty('opacity');
    options.style.removeProperty('height');
    options.style.removeProperty('max-height');
    options.style.removeProperty('overflow');
    options.style.removeProperty('overflow-y');
    options.style.removeProperty('pointer-events');
  }

  function forceUpward(options) {
    options.style.setProperty('top', 'auto', 'important');
    options.style.setProperty('bottom', 'calc(100% + 4px)', 'important');
    options.style.setProperty('left', 'auto', 'important');
    options.style.setProperty('right', '0', 'important');
    options.style.setProperty('width', 'max-content', 'important');
    options.style.setProperty('min-width', '100%', 'important');
    options.style.setProperty('max-width', 'min(220px, calc(100vw - 24px))', 'important');
  }

  function syncTrigger(trigger) {
    const options = getOptions(trigger);
    if (!options) return;

    clearVisibilityInline(options);
    forceUpward(options);

    if (isOpen(trigger)) {
      options.classList.add(OPEN_CLASS);
      options.classList.remove(CLOSED_CLASS);
      return;
    }

    options.classList.remove(OPEN_CLASS);
    options.classList.add(CLOSED_CLASS);
  }

  function syncAll() {
    document.querySelectorAll('.buckscc-select-styled').forEach(syncTrigger);
  }

  function scheduleSync(trigger) {
    SYNC_DELAYS.forEach((delay) => {
      window.setTimeout(() => syncTrigger(trigger), delay);
    });
  }

  function observeTrigger(trigger) {
    if (trigger.dataset.bucksccFloatObserved === 'true') return;
    trigger.dataset.bucksccFloatObserved = 'true';

    new MutationObserver(() => scheduleSync(trigger)).observe(trigger, {
      attributes: true,
      attributeFilter: ['class'],
    });

    syncTrigger(trigger);
  }

  function bindOptions(options) {
    if (options.dataset.bucksccFloatBound === 'true') return;
    options.dataset.bucksccFloatBound = 'true';
    options.classList.add(CLOSED_CLASS);
  }

  function scan() {
    injectOverride();
    document.querySelectorAll('.buckscc-select-styled').forEach(observeTrigger);
    document.querySelectorAll('.buckscc-select-options').forEach(bindOptions);
    syncAll();
  }

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('.buckscc-select-styled');
      if (trigger) {
        scheduleSync(trigger);
        return;
      }

      if (!event.target.closest('.buckscc-select-options')) {
        window.setTimeout(syncAll, 0);
        window.setTimeout(syncAll, 350);
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', scan);

  new MutationObserver((mutations) => {
    if (
      mutations.some((mutation) =>
        [...mutation.addedNodes].some(
          (node) =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.matches?.('.buckscc-select-styled, .buckscc-select-options') ||
              node.querySelector?.('.buckscc-select-styled, .buckscc-select-options'))
        )
      )
    ) {
      scan();
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan();
})();
